import React, {useState, useEffect, useRef} from 'react';

// the useSelector is kind of mapstatetoprops
import {useDispatch} from 'react-redux';

import ButtonLoader, {IButtonLoaderRef} from '../../../com/buttonLoader/ButtonLoader';

import {history} from '../../../helpers/history';
import {useTypedSelector} from '../../../hooks/useTypeSelector';


import {actionCreators} from '../../../store';

import PasswordInput from '../../../com/passwordInput/PasswordInput';

import {ResetPasswordDto, UserDto} from '../../../dtos';

import './SetPassword.scss';

import {validEmailRegex, getVariableName} from '../../../helpers/utils';
import {ActionType} from '../../../store/actionTypes';
import {makeStyles} from "@mui/styles";
import {Typography} from "@mui/material";

const useStyles = makeStyles(() => ({
    formWrapper: {
        width: "100%"
    },
}))


interface IResetPassword {
    onSigninClick: () => void;
    userId: number;
    userEmail: string;
    userToken: string;
}

const SetPassword: React.FC<IResetPassword> = (props) => {

    const classes = useStyles();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [company, setCompany] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    // const [userName, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [verifiedPassword, setVerifiedPassword] = useState('');

    // for testing 
    // const [firstName, setFirstName] = useState('John');
    // const [lastName, setLastName] = useState('Doe');
    // const [company, setCompany] = useState('johndoecompany');
    // const [emailAddress, setEmailAddress] = useState('johndoe@gmail.com');
    // const [userName, setUsername] = useState('johny');
    // const [password, setPassword] = useState('123456');
    // const [verifiedPassword, setVerifiedPassword] = useState('123456');


    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        company: '',
        emailAddress: '',
        // userName: '',
        password: '',
        verifiedPassword: ''
    });

    const hooksNames: string[] = [
        getVariableName({firstName}),
        getVariableName({lastName}),
        getVariableName({company}),
        getVariableName({emailAddress}),
        // getVariableName({userName}),
        getVariableName({password}),
        getVariableName({verifiedPassword}),
    ];


    const {data, loading, type} = useTypedSelector((state) => state.auth);

    const dispatch = useDispatch();

    let buttonLoaderRef = useRef<IButtonLoaderRef>(null);

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!isFormdValid()) {
            return;
        }

        let resetPasswordDto: ResetPasswordDto = {
            userId: props.userId,
            token: props.userToken,
            password: password
        }

        buttonLoaderRef.current?.showLoader(true);

        dispatch(actionCreators.resetPassword(resetPasswordDto));
    }

    const isFormdValid = () => {

        let allErrors = validate();

        // if length === 0 => true
        // else false
        return Object.values(allErrors).join('').length === 0;
    }

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>, hookName: string, hookFunction: React.Dispatch<React.SetStateAction<any>>) => {
        const value = event.target.value;
        hookFunction(value);

        validate(hookName, value);
    }

    const validate = (hookName?: string, enforceValue?: any) => {

        let allErrors: any = {...errors}

        hooksNames.forEach(name => {
            let currentError = validateInput(name, enforceValue);

            if (hookName) {
                // validate only 1 input
                if (name === hookName) {
                    allErrors[name] = currentError;
                }
            } else {
                // validate all inputs
                allErrors[name] = currentError;
            }
        });

        setErrors(allErrors);

        return allErrors;
    }

    const validateInput = (name: string, enforceValue?: any) => {

        let value = null;
        let err = '';

        if (enforceValue === undefined) {
            switch (name) {
                case getVariableName({firstName}):
                    value = enforceValue ? enforceValue : firstName
                    err = value.length < 2
                        ? 'First Name must be at least 2 characters'
                        : ''
                    break;

                case getVariableName({lastName}):
                    value = enforceValue ? enforceValue : lastName
                    err = value.length < 3
                        ? 'Last Name must be at least 3 characters'
                        : ''
                    break;

                case getVariableName({company}):
                    value = enforceValue ? enforceValue : company
                    err = value.length < 6
                        ? 'Company must be at least 3 characters'
                        : ''
                    break;

                case getVariableName({emailAddress}):
                    value = enforceValue ? enforceValue : emailAddress
                    err = !validEmailRegex.test(value)
                        ? 'Email address is wrong'
                        : ''
                    break;

                // case getVariableName({userName}):
                //     value = enforceValue ? enforceValue : userName
                //     err = value.length < 3
                //         ? 'User Name must be at least 3 characters long'
                //         : ''
                // break;

                case getVariableName({password}):
                    value = enforceValue ? enforceValue : password
                    err = value.length < 6
                        ? 'Password must be at least 6 characters'
                        : ''
                    break;

                case getVariableName({verifiedPassword}):
                    value = enforceValue ? enforceValue : verifiedPassword

                    err = value.length < 6
                        ? 'Verified Password must be at least 6 characters'
                        : ''

                    if (err === '' &&
                        value.length !== 0 &&
                        password.length !== 0 &&
                        value !== password) {
                        err = 'Verified Password and Password must match.';
                    }

                    break;
            }
        }

        return err;
    }

    useEffect(() => {
        // will run once
        var userData: UserDto = {
            userId: props.userId,
            token: props.userToken
        }

        dispatch(actionCreators.fetchUserData(userData));
    }, []);

    useEffect(() => {
        if (type === ActionType.REGISTER_SUCCESS) {
            history.push('/flyersCatalog');
            /*
                        if (isMobile || projectName.indexOf('flipbookEditor') > -1) {
                            history.push('/flipbookEditor');
                        } else {
                            history.push('/flyersCatalog');
                        }
            */
        }

        if (type === ActionType.FETCH_USER_DATA_SUCCESS) {
            setFirstName(data!.firstName!);
            setLastName(data!.lastName!);
            setCompany(data!.company!);
            setEmailAddress(data!.emailAddress!);
            // setUsername(data!.userName!);
        }

        if (type === ActionType.RESET_PASSWORD_SUCCESS) {
            setTimeout(() => {
                history.push('/auth')
                props.onSigninClick();
            }, delay);
        }
    })

    const delay = 500;

    useEffect(() => {
        if (!loading) {
            setTimeout(() => {
                buttonLoaderRef.current?.showLoader(false);
            }, delay);
        }
    }, [loading])

    return (
        <div className={classes.formWrapper}>
            <Typography textAlign={"center"}
                        sx={{
                            fontSize: "28px",
                            textAlign: "center",
                            marginBottom: "32px",
                            fontWeight: 500
                        }}

            >
                Set password
            </Typography>

            <Typography textAlign={"center"}
                        sx={{
                            fontSize: "14px",
                            textAlign: "center",
                            marginBottom: "18px",
                            fontWeight: 500
                        }}
            >
                For the account {props.userEmail}
            </Typography>

            <form className="auth_item_container_form" noValidate onSubmit={onSubmit}>
                <div>
                    <label className="form-label">Password</label>
                    <PasswordInput
                        value={password}
                        onChange={e => onInputChange(e, getVariableName({password}), setPassword)}
                        errorMessage={errors.password}
                    />
                </div>
                <div>
                    <label className="form-label">Verify Password</label>
                    <PasswordInput
                        value={verifiedPassword}
                        onChange={e => onInputChange(e, getVariableName({verifiedPassword}), setVerifiedPassword)}
                        errorMessage={errors.verifiedPassword}
                    />
                </div>

                <ButtonLoader ref={buttonLoaderRef}>
                    CONFIRM
                </ButtonLoader>

                {/* <p>Already have an account? <a href="#" onClick={props.onSigninClick}>Sign In</a></p> */}

                {/*<AuthPrivacy/>*/}
            </form>
        </div>
    )
}

export default SetPassword;
